import { ANIMATION_DURATION, TRANSITION_DELAY } from '@/constants/register.contants'
import { Grow, Paper, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import React, { useEffect, useRef, useState } from 'react'

export const UserInfoDisplay: React.FC<UserInfoDisplayProps> = ({ userInfo, onAnimationComplete }) => {
  const [isVisible, setIsVisible] = useState(false)
  const animationCompleteRef = useRef(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, TRANSITION_DELAY)

    return () => clearTimeout(timer)
  }, [])

  const handleEntered = () => {
    if (!animationCompleteRef.current) {
      animationCompleteRef.current = true
      setTimeout(onAnimationComplete, TRANSITION_DELAY)
    }
  }

  return (
    <Grow in={isVisible} timeout={ANIMATION_DURATION} onEntered={handleEntered}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mt: 1,
          mb: 2,
          ml: 'auto',
          width: '90%',
          borderRadius: 4,
          bgcolor: (theme) =>
            theme.palette.mode === 'dark'
              ? alpha(theme.palette.secondary.main, 0.1)
              : alpha(theme.palette.secondary.light, 0.1),
        }}
      >
        <Typography variant="body1" color="text.primary">
          Nice to meet you, I'm <strong>{userInfo.name}</strong>. You can reach me via email at{' '}
          <strong>{userInfo.email}</strong>. My organization is <strong>{userInfo.organization}</strong>.
        </Typography>
      </Paper>
    </Grow>
  )
}
